import React from "react";
import "./styele.css";

const InfoSectionArea = () => {
  return (
    <>
      <div className="Container">
        <div className="rootInfo">
          <div className="ingo i1">
            <div className="text1"> 20+</div>
            <div className="text2">Events</div>
          </div>
          <div className="ingo">
            <div className="text1"> 1500+ </div>
            <div className="text2">Participants</div>
          </div>
          <div className="ingo">
            <div className="text1">100+ </div>
            <div className="text2">Hours</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfoSectionArea;
